import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, createRef } from "react";
import { StyledDynamicDevlinkComponent } from "./dynamic-devlink-component.scss.js";
import DefaultProps from "./default-props";
import { withGenericConfig } from "/contexts/generic-config-context";
import { DEVLINK_COMPONENT_MAP } from "./constants/devlink-component-types";
import { EXTERNAL_SCRIPT_ID } from "./constants/external-script-constants";
import { initSplide } from "./services/splide/index.js";
import { addScriptToDOM } from "./services/external-script-service";
class DynamicDevlinkComponent extends PureComponent {
    componentDidMount() {
        addScriptToDOM();
        initSplide(this.rootRef.current);
    }
    componentWillUnmount() {
        const script = document.getElementById(EXTERNAL_SCRIPT_ID);
        if (script) {
            script.parentNode.removeChild(script);
        }
    }
    renderDevlinkComponent(name) {
        const Component = DEVLINK_COMPONENT_MAP.get(name);
        if (!Component) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Component, {});
    }
    render() {
        const { devlinkComponent } = this.props;
        return /*#__PURE__*/ _jsx(StyledDynamicDevlinkComponent, {
            ref: this.rootRef,
            className: "dynamic-devlink-component",
            children: this.renderDevlinkComponent(devlinkComponent)
        });
    }
    constructor(props){
        super(props);
        this.rootRef = /*#__PURE__*/ createRef();
    }
}
DynamicDevlinkComponent.defaultProps = DefaultProps;
export default withGenericConfig(DynamicDevlinkComponent);
